<template>
  <vs-popup :title="$t('SaleTargets')" :active.sync="showModal">
    <vs-table :data="agentTargets" class="custom-tbl">
      <template slot="thead">
        <th>#</th>
        <th>{{ $t("ItemCode") }}</th>
        <th>{{ $t("Count") }}</th>
        <th>{{ $t("Amount") }}</th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(row, i) in data">
          <vs-td>
            {{ i + 1 }}
          </vs-td>
          <vs-td>
            {{ row.productItemCode }}
          </vs-td>
          <vs-td>
            {{ row.count ? row.count : "-" }}
          </vs-td>
          <vs-td>
            {{ row.amount ? row.amount.toLocaleString() : "-" }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-popup>
</template>

<script>
export default {
  props: {
    show: { default: false },
    agentTargets: { type: Array, required: true },
  },
  watch: {
    show() {},
  },
  data() {
    return {
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {},
};
</script>
